import { forwardRef, ForwardedRef } from 'react'

interface TextareaProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {
    label?: string
    inputId?: string
    error?: {
        message?: string // Allow message to be undefined
    },
    required?: boolean
    placeholder?: string
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ label, inputId, error, required = false, placeholder, ...props }, ref: ForwardedRef<HTMLTextAreaElement>) => (
    <div>
        <label
            htmlFor={inputId}
            className={`
                ${error ? 'text-[var(--theme-danger)]' : 'text-[var(--theme-text)]'} block pl-2.5 text-sm/6 text-[var(--theme-text)] font-[var(--font-weight-bold)] h-6 leading-4 text-pretty ${required ? 'after:ml-1.5 after:content-["*"]' : ''}
                `}
            >
            {label}
        </label>
        <div className='mt-2'>
            <textarea
                ref={ref}
                {...props}
                id={inputId}
                placeholder={placeholder}
                rows={6}
                className={`
                    transition duration-500 appearance-none
                    resize-none block w-full rounded-md bg-white px-3 py-3 text-base outline outline-1
                    placeholder:text-[var(--input-placeholder)]
                    ${error ? 'outline-[var(--theme-danger)] focus:outline-[var(--theme-danger)]' : 'outline-[var(--input-border)] focus:outline-[var(--theme-text)]'}
                    focus:outline-1 sm:text-lg/6
                `}
            />
        </div>
        {error && error.message && <p className='p-0.5 text-md  text-[var(--theme-danger)]'>{error.message}</p>}
    </div>
))

export default Textarea
